export default "__VITE_ASSET__Dr93Njjn__"